/** Painel do departamento pessoal: férias, experiências, afastados e cadastros incompletos de todos os clientes. */
import { createFileRoute } from '@tanstack/react-router';
import { PainelPessoal } from '../telas/pessoal/painel';

export const Route = createFileRoute('/_app/pessoal')({ component: PainelPessoal });
